import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { MuiTextField, MuiSelect, AccordionWithArrow } from '../../../../components'
// import { consoleLog } from '../../../../util'
import { defaultSelectObj } from '../../../../util'

const UserExtendedProperties = ({ data, mode, onChange, expanded }) => {
  const [formSectionData, setFormSectionData] = useState({
    Education: data?.Education || '',
    Occupation: data?.Occupation || '',
    Industry: data?.Industry || '',
    Music: data?.Music || '',
    Books: data?.Books || '',
    Movies: data?.Movies || '',
    Television: data?.Television || '',
    Games: data?.Games || '',
    Interests: data?.Interests || '',
    others: ''
  })

  const [formSelectData, setFormSelectData] = useState({
    Education: [],
    Occupation: []
  })

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formSectionData,
      [key]: value
    }
    setFormSectionData(obj)
    onChange(obj)
  }

  const hasDataAndNotDisabled = (value) => {
    if (mode) { return (value?.length > 0) && mode }
    return true
  }

  useEffect(() => {
    const Education = [
      defaultSelectObj.empty, { label: 'School: 9 years', value: 'School: 9 years' }, { label: 'SSC/HSC', value: 'SSC/HSC' },
      { label: 'College (not graduate)', value: 'College (not graduate)' }, { label: 'Graduate', value: 'Graduate' }, { label: 'Post Graduate', value: 'Post Graduate' }, { label: '', value: '5' }
    ]
    const Occupation = [
      defaultSelectObj.empty, { label: 'Self Employed', value: 'Self Employed' }, { label: 'Working Professional', value: 'Working Professional' }, { label: 'Housewife', value: 'Housewife' },
      { label: 'Student', value: 'Student' }, { label: 'Retired', value: 'Retired' }, { label: 'Unemployed', value: 'Unemployed' }, { label: '', value: '6' }
    ]
    setFormSelectData({
      ...formSelectData,
      Education,
      Occupation
    })
  }, [])

  useEffect(() => {
    if (formSectionData) {
      onChange(formSectionData)
    }
  }, [formSectionData])

  return (
    <AccordionWithArrow title='User Extended Properties' expanded={expanded} accordionstyle='fieldset' showOverlay={mode}>
      <Grid container spacing={2}>
        {hasDataAndNotDisabled(formSectionData?.Education) && <Grid item xs={4}>
          <MuiSelect
            data={formSelectData.Education}
            name='Education'
            // label='Education'
            placeholder='Education'
            onChange={(e) => onChangeHandler('Education', e.target.value)}
            variant='standard'
            value={formSectionData?.Education}
            disabled={mode}
            />
        </Grid>}
        {hasDataAndNotDisabled(formSectionData?.Occupation) && <Grid item xs={4}>
          <MuiSelect
            data={formSelectData.Occupation}
            name='Occupation'
            // label='Occupation'
            placeholder='Occupation'
            onChange={(e) => onChangeHandler('Occupation', e.target.value)}
            variant='standard'
            value={formSectionData?.Occupation || ''}
            disabled={mode}
            multiline
            row={2}
          />
        </Grid>}
        {hasDataAndNotDisabled(formSectionData?.Industry) && <Grid item xs={4}>
          <MuiTextField
            name='Industry'
            // label='Industry'
            placeholder='Industry'
            onChange={(e) => onChangeHandler('Industry', e.target.value)}
            variant='standard'
            value={formSectionData?.Industry || ''}
            disabled={mode}
            multiline
            row={2}
          />
        </Grid>}
        {hasDataAndNotDisabled(formSectionData?.Music) && <Grid item xs={4}>
          <MuiTextField
            name='Music'
            // label='Music (one item per line)'
            placeholder='Music (one item per line)'
            onChange={(e) => onChangeHandler('Music', e.target.value)}
            variant='standard'
            value={formSectionData?.Music || ''}
            disabled={mode}
            multiline
            row={2}
          />
        </Grid>}

        {hasDataAndNotDisabled(formSectionData?.Books) && <Grid item xs={4}>
          <MuiTextField
            name='Books'
            // label='Books (one item per line)'
            placeholder='Books (one item per line)'
            onChange={(e) => onChangeHandler('Books', e.target.value)}
            variant='standard'
            value={formSectionData?.Books || ''}
            disabled={mode}
            multiline
            row={2}
          />
        </Grid>}
        {hasDataAndNotDisabled(formSectionData?.Movies) && <Grid item xs={4}>
          <MuiTextField
            name='Movies'
            // label='Movies (one item per line)'
            placeholder='Movies (one item per line)'
            onChange={(e) => onChangeHandler('Movies', e.target.value)}
            variant='standard'
            value={formSectionData?.Movies || ''}
            disabled={mode}
            multiline
            row={2}
          />
        </Grid>}
        {hasDataAndNotDisabled(formSectionData?.Television) && <Grid item xs={4}>
          <MuiTextField
            name='Television'
            // label='Television (one item per line)'
            placeholder='Television (one item per line)'
            onChange={(e) => onChangeHandler('Television', e.target.value)}
            variant='standard'
            value={formSectionData?.Television || ''}
            disabled={mode}
            multiline
            row={2}
          />
        </Grid>}
        {hasDataAndNotDisabled(formSectionData?.Games) && <Grid item xs={4}>
          <MuiTextField
            name='Games'
            // label='Games (one item per line)'
            placeholder='Games (one item per line)'
            onChange={(e) => onChangeHandler('Games', e.target.value)}
            variant='standard'
            value={formSectionData?.Games || ''}
            disabled={mode}
            multiline
            row={2}
          />
        </Grid>}
        {hasDataAndNotDisabled(formSectionData?.Interests) && <Grid item xs={4}>
          <MuiTextField
            name='Interests'
            // label='As & Is (one item per line)'
            placeholder='As & Is (one item per line)'
            onChange={(e) => onChangeHandler('Interests', e.target.value)}
            variant='standard'
            value={formSectionData?.Interests || ''}
            disabled={mode}
            multiline
            row={2}
          />
        </Grid>}
        {hasDataAndNotDisabled(formSectionData?.others) && <Grid item xs={4}>
          <MuiTextField
            name='others'
            // label='Others (commas delimited)'
            placeholder='Others (commas delimited)'
            onChange={(e) => onChangeHandler('others', e.target.value)}
            variant='standard'
            value={formSectionData?.others || ''}
            disabled={mode}
            multiline
            row={2}
          />
        </Grid>}

      </Grid>
    </AccordionWithArrow>
  )
}

UserExtendedProperties.propTypes = {
  data: PropTypes.object,
  mode: PropTypes.bool,
  onChange: PropTypes.func,
  expanded: PropTypes.bool
}

export default UserExtendedProperties
